import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import UploadVideoFile from '../UI/UploadVideoFile.jsx'
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import Accueil from '../UI/Accueil.jsx';

function VID000100({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVocale,
    changerEtapeCollecteParticipationVideo,

    setContinueEnabled,
    continueEnabled,

    videoBlob,
    setVideoBlob,
    videoURL,
    setVideoURL,
    sendRecordParticipation,
    sendingParticipationState,

    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setRememberMe,
    setField,
    saveDonneePersonnelle,
    setMessageErreur,
    userInformation,
    retourAccueil,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    donneesPersonnelleValid,
    participation,
}) {
    return (
        <>
            <Row className="custom-instructions">
                <Col>
                    <Titre interaction={interaction} />
                </Col>
            </Row>
            {afficherAccueil &&
                // Page d accueil
                <>
                    <Accueil
                        interaction={interaction}
                        changerPage={changerAfficherEtapeCollecteParticipation}
                    />
                </>
            }
            {afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>

                    <Row className="custom-collecte-participation">
                        <Col>
                            <UploadVideoFile
                                participation={participation}
                                changerEtapeCollecteParticipation={changerEtapeCollecteParticipationVideo}
                            />
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {afficherEtapeCollectInformationsPersonnelles &&
                <>
                    <DonneesPersonnelles
                        interaction={interaction}
                        setField={setField}
                        userInformation={userInformation}
                        donneesPersonnelleValid={donneesPersonnelleValid}
                        handleRememberMeChange={handleRememberMeChange}
                        rememberMe={rememberMe}
                        canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                        saveDonneePersonnelle={saveDonneePersonnelle}
                    />
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {afficherEtapeGRPD &&
                <>
                    <Consent
                        customisation={interaction.segment_customisation}
                        consentGDPR={consentGDPR}
                        consentImage={consentImage}
                        setConsent={setConsent}
                    />
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {afficherEtapeRemerciement &&
                <>
                    <Row className="custom-commandes">
                        <Col>
                            <Remerciement interaction={interaction} >Continuer</Remerciement>
                        </Col>
                    </Row>

                </>
                // Page de remerciemeent
            }
        </>
    )
}
export default VID000100;
